module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "news-content",
    staticStyle: {
      "padding": "0 10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.row.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "course-box"
  }, _vm._l((_vm.courseList), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "course-items",
      on: {
        "click": function($event) {
          return _vm.goCourseDetail(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "course-pic-box"
    }, [_c('img', {
      attrs: {
        "width": "100%",
        "src": item.pic_url,
        "alt": ""
      }
    }), _vm._v(" "), (item.level) ? _c('span', [_vm._v(_vm._s(item.level))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "course-title  "
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "course-price-box"
    }, [(item.price > 0) ? _c('span', {
      staticClass: "course-price"
    }, [_vm._v("¥" + _vm._s(item.price))]) : _vm._e(), (item.video_count > 0) ? _c('span', {
      staticClass: "course-num"
    }, [_vm._v(_vm._s(item.video_count) + "视频")]) : _vm._e()])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76ee77b3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/page/2022331.vue
// module id = 2488
// module chunks = 0